export const DEFAULT_LANGUAGE = "en";
export const FALLBACK_LANGUAGE = "en";
export const DEFAULT_NAMESPACE = "general";
export const LANGUAGE_STORAGE_KEY = "app-language";

export const LANGUAGE_OPTIONS = [
  { value: "en", label: "English" },
  { value: "id", label: "Bahasa Indonesia" },
] as const;
